import classNames from 'classnames';
import { StateUpdater, useRef } from 'preact/hooks';
import { useOnClickOutside } from 'usehooks-ts';

type Props = {
  label: string;
  sizeVariant: string;
  setClickOutside?: StateUpdater<boolean>;
  stylingClass?: string;
};

export const SubmitButton = ({
  label,
  sizeVariant,
  setClickOutside,
  stylingClass,
}: Props) => {
  const classes = classNames(
    'bo-btn',
    {
      [`bo-btn--${sizeVariant}`]: !!sizeVariant,
    },
    `${stylingClass || ''}`,
  );

  const buttonRef = useRef<HTMLButtonElement>(null);

  useOnClickOutside(buttonRef, () => setClickOutside && setClickOutside(true));

  return (
    <button
      ref={buttonRef}
      className={classes}
      type="submit"
      onClick={() => setClickOutside && setClickOutside(false)}
    >
      <span>{label}</span>
    </button>
  );
};
